module.exports = __webpack_public_path__ + "static/media/Bossini.595325b3.png";